import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import VueElementLoading from 'vue-element-loading'
import CryptoJS from 'crypto-js'
import Pagination from './../shared/pagination'
export default {
	name: 'wavecreation',
	components: {
		//Paginate,
		Pagination,
		DatePicker,
		VueElementLoading
	},
	data() {
		return {
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			// getNewWarehouseData:'',
			listPickerData: [],
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			orderid: "",
			fromDateFlt: "",
			toDateFlt: "",
			newActionMsg: "",
			modelMessage: "",
			// totalPage: 0,
			// pageNo: 0,
			activeClass: 'btn-success',
			warningClass: 'btn-warning',
			clientdata: [],
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			SelectPickerErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			waveAssignmentShow: false,
			cancelOrderId: [],
			loginuserid: '',
			// searchchannel: '',
			channellist: [],
			pickerid: '',
			isLoading: false,
			waveListData: '',
			//pageLimit: 10,
			userEmail: '',
			selectAll: false,
			orderids: [],
			// orderclass: '',
		}
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);

		var roleids = userdetail.roleid.split(',');
		for (var i = 0; i < roleids.length; i++) {
			if (roleids[i] == 40) {
				this.purchasingManager = parseInt(userdetail.roleid);
				this.isTrue = true;
			}
		}
		this.loginuserid = userdetail.userid;
		this.userEmail = userdetail.email;
		this.pageNo = 0;

		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.getPickersList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	}, // End computed
	methods: {
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},

		selectAllCheckbox: function() {
			//this.rackIds = [];
			if (this.selectAll) {
				for (let order in this.listPickerData) {
					if (this.orderids.indexOf(this.listPickerData[order].id) == -1)
						this.orderids.push(this.listPickerData[order].id);
				}
			} else {
				for (let order in this.listPickerData) {
					if (this.orderids.indexOf(this.listPickerData[order].id) >= 0)
						this.orderids.splice(this.orderids.indexOf(this.listPickerData[order].id), 1);
				}
			}
		},
		resetAll: function(myAction) {
			if (myAction == 1) {
				this.orderids = [];
				this.selectAll = false;
			} else {}
		},

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		payloaddateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		getPickersList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: this.warehouseid,
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehousePickerList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.waveListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		if (this.clientid)
		// 			// this.getSalesChannels();
		// 			if (this.user_type != 'warehouse_user') {
		// 				this.listWarehouseData = []
		// 				this.getWarehouseList();
		// 				if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 					this.warehouse = this.warehouseid = '';
		// 				} else {
		// 					this.warehouse = ''
		// 				}
		// 			} else {
		// 				if (this.warehouseid && this.clientid) {
		// 					this.getPickersList();
		// 					//this.getOrderList();
		// 				}
		// 			}
		// 		this.orderids = [];
		// 	}
		// 	this.totalRows = 0;
		// 	this.listPickerData = [];
		// 	this.pageNo = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.listPickerData = [];
		// 	this.pageNo = this.totalPage = 0;
		// 	this.totalRows = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getPickersList();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		// getSalesChannels() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		//
		// 	if (this.clientid == '') {
		// 		this.WarehouseErr = "Client is required";
		// 		return false;
		// 	}
		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'orderSalesChannelList',
		// 			'data': {
		// 				clientid: this.clientid
		// 			},
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.channellist = result.data.data;
		// 		}, error => {
		// 			console.error(error);
		// 		});
		// },
		getOrderList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.fromdate != "") {
				this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
			}
			if (this.todate != "") {
				this.todate = this.dateFormat(this.todate) + " 23:59:59";
			}
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listPickerData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listPickerData = [];
				return false;
			}

			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				orderid: this.orderid.trim(),
				fromddate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getconsounallocatedlist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listPickerData = result.data.data;

					if (result.data.data.ErrorCode == 1) {
						this.resultCount = 0;
					} else {
						this.totalRows = result.data.count;
						this.resultCount = result.data.count;

						if (this.resultCount > 0) {
							if (this.totalRows < this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.resultCount / this.pageLimit)
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},
		assignOrderToPicker() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.waveAssignmentShow = false;
			if (this.client == '') {
				this.$alertify.error(this.$t('common.pleaseSelectClientError'));
				return false;
			}
			if (this.pickerid == 0) {
				this.$alertify.error(this.$t('common.selectPickerErr'));
				return false;
			}
			if (this.orderids.length == 0) {
				this.$alertify.error(this.$t('common.selectAtLeastOneOrderErr'));
				return false;
			}
			this.isLoading = true;
			this.input = {
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				selectedorder: this.orderids,
				userid: this.loginuserid,
				pickerid: this.pickerid,
				useremail: this.userEmail
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'assignOrderToconsoPicker',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.totalPage = this.totalPage - this.orderids.length
						this.$alertify.success(result.data.data.msg);
						//this.getPaginationData(this.totalPage)
						this.getOrderList();
					} else {
						this.$alertify.error(result.data.data.msg);
					}
					this.isLoading = false;
					this.selectAll = false;
					this.pickerid = '';
					this.orderids = [];

				}, error => {
					console.error(error);
				});
		},

		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.pageLimit
		// 	this.getOrderList()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getOrderList()
		},
		getOrderSerach() {
			this.totalPage = 0;
			this.currentPage = 1;
			this.resultCount = 0;
			this.searchFlag = true;
			this.getOrderList();
		},
		resetOrderSerach() {
			this.totalRows = 0;
			this.orderid = '';
			this.fromDateFlt = "";
			this.toDateFlt = "";
			// this.orderclass = '';
			// this.searchchannel = '';
			this.listPickerData = [];
			this.pageNo = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = false;
			this.pickerid = '';
			this.orderids = [];
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},

		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	} // end methods
};


// WEBPACK FOOTER //
// ./src/views/components/wavecreation/wavecreation.component.js